import { DATE_FORMAT } from "constants"
import { dateTimeFunction } from "utils/date"

const assessmentsTransformer = data => {
  return data?.map((item, index) => {
    return {
      label: `${dateTimeFunction(item?.createdAt, DATE_FORMAT)} - ${item?.LogAddedBy?.name} - ${
        item?.LogAddedBy?.UserDesignation?.name
      }`,
      value: item?.id,
    }
  })
}

export default assessmentsTransformer
